import { Col, Table } from 'antd'
import React from 'react'
import { currentLocations } from '../../../../data/currentLocations'

import './CurrentLoginLocations.css'
function CurrentLoginLocations() {
  return (
    <div className='current-login-locations'>
      <Col span={24} >
        <Table dataSource={currentLocations} columns={[
            {
                dataIndex:"browser",
                title: "Browser",
                key:"browser",


            },
            {
                dataIndex:"operatingSystem",
                title: "Operating System",
                key:"operatingSystem",

            },
            {
                dataIndex:"approximateLocation",
                title: "Approximate Location (IP Adddress)",
                key:"approximateLocation",
                render: (text) => <span className="onclick-text">{text}</span>

            },
            {
                dataIndex:"lastSignedIn",
                title: "Last Signed In",
                key:"lastSignedIn",
            },
        ]} />
      </Col>
    </div>
  )
}

export default CurrentLoginLocations
